module.exports = __webpack_public_path__ + "img/img-placeholder.a92265ec.svg";